export default "__VITE_ASSET__lxti6VEB__"